/**
 * Transforms ShareholdersService.fetchList response into the ownership-graph structure.
 *
 * Hierarchy:
 * - First UBO (or first shareholder if none) becomes the main/root node (`from_cin`)
 * - All remaining shareholders become children of that root
 *   (the graph component supports a single main node)
 */
export const transformShareholdersToGraph = (shareholdersData) => {
    const individuals = shareholdersData?.individual || [];
    const companies = shareholdersData?.company || [];

    if (!individuals.length && !companies.length) {
        return null;
    }

    const entities = [];

    individuals.forEach((item) => {
        entities.push({
            cin: `person-${item.id}`,
            name: `${item.firstName || ''} ${item.lastName || ''}`.trim(),
            type: 'persons',
            percentage: item.percentage,
            isUbo: !!item.isUbo,
        });
    });

    companies.forEach((item) => {
        entities.push({
            cin: `company-${item.id}`,
            name: item.companyName || '',
            type: 'companies',
            percentage: item.percentage,
            isUbo: !!item.isUbo,
        });
    });

    const ubos = entities.filter((entity) => entity.isUbo);
    const root = ubos[0] || entities[0];
    const children = entities.filter((entity) => entity.cin !== root.cin);

    const relations = children.map((child) => ({
        from: root.cin,
        to: child.cin,
        percentage: Number(child.percentage) || 0,
    }));

    return {
        from_cin: root.cin,
        entities: entities.map(({ cin, name, type }) => ({
            cin,
            name,
            type,
        })),
        relations,
    };
};
